export interface ITaxAnalytics {
  country_name: string,
  tax: number
}
